/**
 * Extract a human-readable error message from an axios error.
 *
 * El backend Python envuelve respuestas 4xx/5xx con `DorilonJSONRenderer` como:
 *   { "success": false, "error": ... }
 *
 * El campo `error` puede ser:
 *   - string: mensaje directo
 *   - array: lista de errores (e.g. validación Ninja con `loc` + `msg`)
 *   - object: dict con campo `detail` (string u objeto)
 *
 * Antes del fix los stores hacían `err.response?.data?.error ?? err.message`
 * y el resultado para arrays/objetos quedaba como `"[object Object]"` en la UI.
 */
export function extractErrorMessage(err) {
  const data = err?.response?.data?.error
  if (data == null || data === '') return err?.message || 'Error desconocido'
  if (typeof data === 'string') return data
  if (Array.isArray(data)) {
    return data
      .map(e => {
        if (e == null) return ''
        if (typeof e === 'string') return e
        if (typeof e === 'object') return e.msg || e.message || JSON.stringify(e)
        return String(e)
      })
      .filter(Boolean)
      .join('; ')
  }
  if (typeof data === 'object') {
    if (data.detail != null) {
      return typeof data.detail === 'string' ? data.detail : JSON.stringify(data.detail)
    }
    if (data.message != null) {
      return typeof data.message === 'string' ? data.message : JSON.stringify(data.message)
    }
    return JSON.stringify(data)
  }
  return String(data)
}
